export class CorePropertiesImporter {
    constructor(data) {
        this.data = data;
    }
    import(_rootRelations) {
    }
}
